/*!
 * @kurkle/color v0.3.4
 * https://github.com/kurkle/color#readme
 * (c) 2024 Jukka Kurkela
 * Released under the MIT License
 */
function m(t) {
  return t + 0.5 | 0;
}
const d = (t, e, r) => Math.max(Math.min(t, r), e);
function l(t) {
  return d(m(t * 2.55), 0, 255);
}
function o(t) {
  return d(m(t * 255), 0, 255);
}
function g(t) {
  return d(m(t / 2.55) / 100, 0, 1);
}
function _(t) {
  return d(m(t * 100), 0, 100);
}
const c = { 0: 0, 1: 1, 2: 2, 3: 3, 4: 4, 5: 5, 6: 6, 7: 7, 8: 8, 9: 9, A: 10, B: 11, C: 12, D: 13, E: 14, F: 15, a: 10, b: 11, c: 12, d: 13, e: 14, f: 15 }, x = [..."0123456789ABCDEF"], $ = (t) => x[t & 15], E = (t) => x[(t & 240) >> 4] + x[t & 15], p = (t) => (t & 240) >> 4 === (t & 15), R = (t) => p(t.r) && p(t.g) && p(t.b) && p(t.a);
function A(t) {
  var e = t.length, r;
  return t[0] === "#" && (e === 4 || e === 5 ? r = {
    r: 255 & c[t[1]] * 17,
    g: 255 & c[t[2]] * 17,
    b: 255 & c[t[3]] * 17,
    a: e === 5 ? c[t[4]] * 17 : 255
  } : (e === 7 || e === 9) && (r = {
    r: c[t[1]] << 4 | c[t[2]],
    g: c[t[3]] << 4 | c[t[4]],
    b: c[t[5]] << 4 | c[t[6]],
    a: e === 9 ? c[t[7]] << 4 | c[t[8]] : 255
  })), r;
}
const U = (t, e) => t < 255 ? e(t) : "";
function V(t) {
  var e = R(t) ? $ : E;
  return t ? "#" + e(t.r) + e(t.g) + e(t.b) + U(t.a, e) : void 0;
}
const W = /^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;
function P(t, e, r) {
  const a = e * Math.min(r, 1 - r), n = (s, f = (s + t / 30) % 12) => r - a * Math.max(Math.min(f - 3, 9 - f, 1), -1);
  return [n(0), n(8), n(4)];
}
function H(t, e, r) {
  const a = (n, s = (n + t / 60) % 6) => r - r * e * Math.max(Math.min(s, 4 - s, 1), 0);
  return [a(5), a(3), a(1)];
}
function q(t, e, r) {
  const a = P(t, 1, 0.5);
  let n;
  for (e + r > 1 && (n = 1 / (e + r), e *= n, r *= n), n = 0; n < 3; n++)
    a[n] *= 1 - e - r, a[n] += e;
  return a;
}
function L(t, e, r, a, n) {
  return t === n ? (e - r) / a + (e < r ? 6 : 0) : e === n ? (r - t) / a + 2 : (t - e) / a + 4;
}
function F(t) {
  const e = t.r / 255, r = t.g / 255, a = t.b / 255, n = Math.max(e, r, a), s = Math.min(e, r, a), f = (n + s) / 2;
  let i, u, b;
  return n !== s && (b = n - s, u = f > 0.5 ? b / (2 - n - s) : b / (n + s), i = L(e, r, a, b, n), i = i * 60 + 0.5), [i | 0, u || 0, f];
}
function M(t, e, r, a) {
  return (Array.isArray(e) ? t(e[0], e[1], e[2]) : t(e, r, a)).map(o);
}
function X(t, e, r) {
  return M(P, t, e, r);
}
function N(t, e, r) {
  return M(q, t, e, r);
}
function K(t, e, r) {
  return M(H, t, e, r);
}
function T(t) {
  return (t % 360 + 360) % 360;
}
function j(t) {
  const e = W.exec(t);
  let r = 255, a;
  if (!e)
    return;
  e[5] !== a && (r = e[6] ? l(+e[5]) : o(+e[5]));
  const n = T(+e[2]), s = +e[3] / 100, f = +e[4] / 100;
  return e[1] === "hwb" ? a = N(n, s, f) : e[1] === "hsv" ? a = K(n, s, f) : a = X(n, s, f), {
    r: a[0],
    g: a[1],
    b: a[2],
    a: r
  };
}
function C(t, e) {
  var r = F(t);
  r[0] = T(r[0] + e), r = X(r), t.r = r[0], t.g = r[1], t.b = r[2];
}
function Q(t) {
  if (!t)
    return;
  const e = F(t), r = e[0], a = _(e[1]), n = _(e[2]);
  return t.a < 255 ? `hsla(${r}, ${a}%, ${n}%, ${g(t.a)})` : `hsl(${r}, ${a}%, ${n}%)`;
}
const S = {
  x: "dark",
  Z: "light",
  Y: "re",
  X: "blu",
  W: "gr",
  V: "medium",
  U: "slate",
  A: "ee",
  T: "ol",
  S: "or",
  B: "ra",
  C: "lateg",
  D: "ights",
  R: "in",
  Q: "turquois",
  E: "hi",
  P: "ro",
  O: "al",
  N: "le",
  M: "de",
  L: "yello",
  F: "en",
  K: "ch",
  G: "arks",
  H: "ea",
  I: "ightg",
  J: "wh"
}, k = {
  OiceXe: "f0f8ff",
  antiquewEte: "faebd7",
  aqua: "ffff",
  aquamarRe: "7fffd4",
  azuY: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "0",
  blanKedOmond: "ffebcd",
  Xe: "ff",
  XeviTet: "8a2be2",
  bPwn: "a52a2a",
  burlywood: "deb887",
  caMtXe: "5f9ea0",
  KartYuse: "7fff00",
  KocTate: "d2691e",
  cSO: "ff7f50",
  cSnflowerXe: "6495ed",
  cSnsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "ffff",
  xXe: "8b",
  xcyan: "8b8b",
  xgTMnPd: "b8860b",
  xWay: "a9a9a9",
  xgYF: "6400",
  xgYy: "a9a9a9",
  xkhaki: "bdb76b",
  xmagFta: "8b008b",
  xTivegYF: "556b2f",
  xSange: "ff8c00",
  xScEd: "9932cc",
  xYd: "8b0000",
  xsOmon: "e9967a",
  xsHgYF: "8fbc8f",
  xUXe: "483d8b",
  xUWay: "2f4f4f",
  xUgYy: "2f4f4f",
  xQe: "ced1",
  xviTet: "9400d3",
  dAppRk: "ff1493",
  dApskyXe: "bfff",
  dimWay: "696969",
  dimgYy: "696969",
  dodgerXe: "1e90ff",
  fiYbrick: "b22222",
  flSOwEte: "fffaf0",
  foYstWAn: "228b22",
  fuKsia: "ff00ff",
  gaRsbSo: "dcdcdc",
  ghostwEte: "f8f8ff",
  gTd: "ffd700",
  gTMnPd: "daa520",
  Way: "808080",
  gYF: "8000",
  gYFLw: "adff2f",
  gYy: "808080",
  honeyMw: "f0fff0",
  hotpRk: "ff69b4",
  RdianYd: "cd5c5c",
  Rdigo: "4b0082",
  ivSy: "fffff0",
  khaki: "f0e68c",
  lavFMr: "e6e6fa",
  lavFMrXsh: "fff0f5",
  lawngYF: "7cfc00",
  NmoncEffon: "fffacd",
  ZXe: "add8e6",
  ZcSO: "f08080",
  Zcyan: "e0ffff",
  ZgTMnPdLw: "fafad2",
  ZWay: "d3d3d3",
  ZgYF: "90ee90",
  ZgYy: "d3d3d3",
  ZpRk: "ffb6c1",
  ZsOmon: "ffa07a",
  ZsHgYF: "20b2aa",
  ZskyXe: "87cefa",
  ZUWay: "778899",
  ZUgYy: "778899",
  ZstAlXe: "b0c4de",
  ZLw: "ffffe0",
  lime: "ff00",
  limegYF: "32cd32",
  lRF: "faf0e6",
  magFta: "ff00ff",
  maPon: "800000",
  VaquamarRe: "66cdaa",
  VXe: "cd",
  VScEd: "ba55d3",
  VpurpN: "9370db",
  VsHgYF: "3cb371",
  VUXe: "7b68ee",
  VsprRggYF: "fa9a",
  VQe: "48d1cc",
  VviTetYd: "c71585",
  midnightXe: "191970",
  mRtcYam: "f5fffa",
  mistyPse: "ffe4e1",
  moccasR: "ffe4b5",
  navajowEte: "ffdead",
  navy: "80",
  Tdlace: "fdf5e6",
  Tive: "808000",
  TivedBb: "6b8e23",
  Sange: "ffa500",
  SangeYd: "ff4500",
  ScEd: "da70d6",
  pOegTMnPd: "eee8aa",
  pOegYF: "98fb98",
  pOeQe: "afeeee",
  pOeviTetYd: "db7093",
  papayawEp: "ffefd5",
  pHKpuff: "ffdab9",
  peru: "cd853f",
  pRk: "ffc0cb",
  plum: "dda0dd",
  powMrXe: "b0e0e6",
  purpN: "800080",
  YbeccapurpN: "663399",
  Yd: "ff0000",
  Psybrown: "bc8f8f",
  PyOXe: "4169e1",
  saddNbPwn: "8b4513",
  sOmon: "fa8072",
  sandybPwn: "f4a460",
  sHgYF: "2e8b57",
  sHshell: "fff5ee",
  siFna: "a0522d",
  silver: "c0c0c0",
  skyXe: "87ceeb",
  UXe: "6a5acd",
  UWay: "708090",
  UgYy: "708090",
  snow: "fffafa",
  sprRggYF: "ff7f",
  stAlXe: "4682b4",
  tan: "d2b48c",
  teO: "8080",
  tEstN: "d8bfd8",
  tomato: "ff6347",
  Qe: "40e0d0",
  viTet: "ee82ee",
  JHt: "f5deb3",
  wEte: "ffffff",
  wEtesmoke: "f5f5f5",
  Lw: "ffff00",
  LwgYF: "9acd32"
};
function B() {
  const t = {}, e = Object.keys(k), r = Object.keys(S);
  let a, n, s, f, i;
  for (a = 0; a < e.length; a++) {
    for (f = i = e[a], n = 0; n < r.length; n++)
      s = r[n], i = i.replace(s, S[s]);
    s = parseInt(k[f], 16), t[i] = [s >> 16 & 255, s >> 8 & 255, s & 255];
  }
  return t;
}
let y;
function D(t) {
  y || (y = B(), y.transparent = [0, 0, 0, 0]);
  const e = y[t.toLowerCase()];
  return e && {
    r: e[0],
    g: e[1],
    b: e[2],
    a: e.length === 4 ? e[3] : 255
  };
}
const I = /^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;
function J(t) {
  const e = I.exec(t);
  let r = 255, a, n, s;
  if (e) {
    if (e[7] !== a) {
      const f = +e[7];
      r = e[8] ? l(f) : d(f * 255, 0, 255);
    }
    return a = +e[1], n = +e[3], s = +e[5], a = 255 & (e[2] ? l(a) : d(a, 0, 255)), n = 255 & (e[4] ? l(n) : d(n, 0, 255)), s = 255 & (e[6] ? l(s) : d(s, 0, 255)), {
      r: a,
      g: n,
      b: s,
      a: r
    };
  }
}
function z(t) {
  return t && (t.a < 255 ? `rgba(${t.r}, ${t.g}, ${t.b}, ${g(t.a)})` : `rgb(${t.r}, ${t.g}, ${t.b})`);
}
const v = (t) => t <= 31308e-7 ? t * 12.92 : Math.pow(t, 1 / 2.4) * 1.055 - 0.055, h = (t) => t <= 0.04045 ? t / 12.92 : Math.pow((t + 0.055) / 1.055, 2.4);
function G(t, e, r) {
  const a = h(g(t.r)), n = h(g(t.g)), s = h(g(t.b));
  return {
    r: o(v(a + r * (h(g(e.r)) - a))),
    g: o(v(n + r * (h(g(e.g)) - n))),
    b: o(v(s + r * (h(g(e.b)) - s))),
    a: t.a + r * (e.a - t.a)
  };
}
function Y(t, e, r) {
  if (t) {
    let a = F(t);
    a[e] = Math.max(0, Math.min(a[e] + a[e] * r, e === 0 ? 360 : 1)), a = X(a), t.r = a[0], t.g = a[1], t.b = a[2];
  }
}
function Z(t, e) {
  return t && Object.assign(e || {}, t);
}
function O(t) {
  var e = { r: 0, g: 0, b: 0, a: 255 };
  return Array.isArray(t) ? t.length >= 3 && (e = { r: t[0], g: t[1], b: t[2], a: 255 }, t.length > 3 && (e.a = o(t[3]))) : (e = Z(t, { r: 0, g: 0, b: 0, a: 1 }), e.a = o(e.a)), e;
}
function ee(t) {
  return t.charAt(0) === "r" ? J(t) : j(t);
}
class w {
  constructor(e) {
    if (e instanceof w)
      return e;
    const r = typeof e;
    let a;
    r === "object" ? a = O(e) : r === "string" && (a = A(e) || D(e) || ee(e)), this._rgb = a, this._valid = !!a;
  }
  get valid() {
    return this._valid;
  }
  get rgb() {
    var e = Z(this._rgb);
    return e && (e.a = g(e.a)), e;
  }
  set rgb(e) {
    this._rgb = O(e);
  }
  rgbString() {
    return this._valid ? z(this._rgb) : void 0;
  }
  hexString() {
    return this._valid ? V(this._rgb) : void 0;
  }
  hslString() {
    return this._valid ? Q(this._rgb) : void 0;
  }
  mix(e, r) {
    if (e) {
      const a = this.rgb, n = e.rgb;
      let s;
      const f = r === s ? 0.5 : r, i = 2 * f - 1, u = a.a - n.a, b = ((i * u === -1 ? i : (i + u) / (1 + i * u)) + 1) / 2;
      s = 1 - b, a.r = 255 & b * a.r + s * n.r + 0.5, a.g = 255 & b * a.g + s * n.g + 0.5, a.b = 255 & b * a.b + s * n.b + 0.5, a.a = f * a.a + (1 - f) * n.a, this.rgb = a;
    }
    return this;
  }
  interpolate(e, r) {
    return e && (this._rgb = G(this._rgb, e._rgb, r)), this;
  }
  clone() {
    return new w(this.rgb);
  }
  alpha(e) {
    return this._rgb.a = o(e), this;
  }
  clearer(e) {
    const r = this._rgb;
    return r.a *= 1 - e, this;
  }
  greyscale() {
    const e = this._rgb, r = m(e.r * 0.3 + e.g * 0.59 + e.b * 0.11);
    return e.r = e.g = e.b = r, this;
  }
  opaquer(e) {
    const r = this._rgb;
    return r.a *= 1 + e, this;
  }
  negate() {
    const e = this._rgb;
    return e.r = 255 - e.r, e.g = 255 - e.g, e.b = 255 - e.b, this;
  }
  lighten(e) {
    return Y(this._rgb, 2, e), this;
  }
  darken(e) {
    return Y(this._rgb, 2, -e), this;
  }
  saturate(e) {
    return Y(this._rgb, 1, e), this;
  }
  desaturate(e) {
    return Y(this._rgb, 1, -e), this;
  }
  rotate(e) {
    return C(this._rgb, e), this;
  }
}
export {
  w as Color,
  g as b2n,
  A as hexParse,
  V as hexString,
  X as hsl2rgb,
  Q as hslString,
  K as hsv2rgb,
  j as hueParse,
  N as hwb2rgb,
  d as lim,
  o as n2b,
  _ as n2p,
  D as nameParse,
  l as p2b,
  F as rgb2hsl,
  J as rgbParse,
  z as rgbString,
  C as rotate,
  m as round
};
//# sourceMappingURL=index.es150.js.map
